import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@purespectrum1/ui/button';
import { AuthGuard } from '../auth/auth.guard';
import { FeatureFlagGuard } from '../auth/feature-flag.guard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '../layout/layout.module';
import { TransactionsToolComponent } from './transactions-tool/transactions-tool.component';
import { BuyerSurveySimulatorComponent } from './buyer-survey-simulator/buyer-survey-simulator.component';

@NgModule({
  declarations: [TransactionsToolComponent, BuyerSurveySimulatorComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RouterModule.forChild([
      {
        path: 'tools',
        canActivate: [AuthGuard],
        children: [
          {
            path: 'transactions-tool',
            component: TransactionsToolComponent,
            canActivate: [FeatureFlagGuard],
            data: { flagName: 'enableTransactionTestingTool' },
          },
        ],
      },
      {
        path: 'buyer-survey-simulator',
        component: BuyerSurveySimulatorComponent,
      },
    ]),
    LayoutModule,
  ],
})
export class PsToolsModule {}
